module.exports = __webpack_public_path__ + "static/img/logo.24e29bf1.svg";